import React from 'react'
import styled, { css } from 'styled-components'
import Close from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/33-Form-Validation/Close'

// ==================== TYPES ====================

interface ISmallXButton {
  smallXButton?: boolean
}

export interface SelectedItemProps extends ISmallXButton {
  data?: unknown
  name?: string
  disabled?: boolean
  closeHidden?: boolean
  error?: boolean
  loading?: boolean
  onClose?: (_data: unknown) => void
}

// ==================== STYLES ====================

const CloseWrapper = styled.div<ISmallXButton>`
  display: flex;
  margin-left: auto;
  align-items: center;
  justify-content: center;

  ${({ theme, smallXButton }) => css`
    height: ${smallXButton ? '14px' : 'initial'};
    width: ${smallXButton ? '14px' : 'initial'};

    & > div {
      background-color: transparent;
      width: auto;
      height: auto;
      & > span {
        height: ${smallXButton ? '14px' : '20px'};
        width: ${smallXButton ? '14px' : '20px'};
        border-top: 3px solid ${theme.colors.brandPrimaryContrast};
        border-right: 3px solid ${theme.colors.brandPrimaryContrast};
        border-bottom: 3px solid ${theme.colors.brandPrimaryContrast};
      }
    }

    svg {
      font-size: ${smallXButton ? '14px' : '20px'};
      cursor: pointer;
      user-select: none;
    }
  `}
`

const Wrapper = styled.div<{ error?: boolean; disabled?: boolean; loading?: boolean }>`
  display: flex;
  flex-flow: column;
  ${({ theme, error, disabled, loading }) => css`
    border: 1px solid
      ${error && !disabled ? theme.palette.danger100 : loading ? theme.palette.blue30 : theme.palette.gray100};
    border-radius: ${theme.radius.sm};
    padding: ${theme.space.xs};
    line-height: 1.14;
    letter-spacing: 0.49px;
    font-size: ${theme.fontSize.xxs};
    background-color: ${error && !disabled
      ? theme.palette.danger10
      : loading
        ? theme.palette.blue10
        : theme.colors.brandSupporting01Contrast};
    color: ${disabled ? theme.palette.gray100 : loading ? theme.palette.blue50 : 'inherit'};

    ${CloseWrapper} {
      color: ${disabled ? theme.palette.gray100 : theme.palette.danger100};
      svg {
        color: ${disabled ? theme.palette.gray100 : theme.palette.danger100};
      }
    }
  `}
`

const Details = styled.div`
  display: flex;
`

const Content = styled.div<{ closeHidden?: boolean }>`
  display: flex;
  flex-flow: column;

  ${({ theme, closeHidden }) => css`
    color: ${closeHidden ? theme.palette.gray100 : ''};
  `}
`

// ==================== COMPONENT ====================

const noop = () => {}

const SelectedItem: React.FC<SelectedItemProps> = ({
  data,
  name,
  loading,
  disabled,
  closeHidden,
  onClose = noop,
  smallXButton,
}) => {
  return (
    <Wrapper>
      <Details>
        <Content closeHidden={closeHidden}>
          <div>{name}</div>
        </Content>
        {!closeHidden && (
          <CloseWrapper onClick={() => !disabled && !loading && onClose(data)} smallXButton={smallXButton}>
            <Close />
          </CloseWrapper>
        )}
      </Details>
    </Wrapper>
  )
}

export default SelectedItem

